export default __webpack_public_path__ + "static/media/mom.a6cc4d2e.png";